import React from 'react';
import logo from './logo.svg';
import './App.css';
import Search from './components/Search';
import Home from './components/Home';
import News from './components/News';
import Developer from './components/Developer';

import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

function App() {
	return (
		<div>
			<Router>
				<div>
					<Switch>
						<Route exact path='/'>
							<Home />
						</Route>
						<Route path='/developer'>
							<Developer />
						</Route>
						<Route path='/news/:type/:code'>
							<News />
						</Route>
					</Switch>
				</div>
			</Router>
		</div>
	);
}

export default App;
